import type { FunctionComponent } from 'react'
import React, { useState } from 'react'
import { Grid, GridItem, PageTitle, Picture } from '@which/seatbelt'

import classnames from 'classnames'

import { PIRole } from '../PIRole'
import { PISearchBox } from '../PISearchBox'
import styles from './PIHero.module.scss'

export const PIHero: FunctionComponent<Props> = ({
  title,
  standfirst,
  searchBar,
  basic = false,
  subtext = '',
  buttonsRole = [{ id: '', displayText: '', href: '' }],
  image,
}) => {
  const [searchTerm, setSearchTerm] = useState('')

  return (
    <Grid
      className={classnames(styles.heroWrapper, { [styles.heroWrapperBasic]: basic })}
      data-testid="ea-hero"
    >
      <GridItem
        span={{ large: basic ? 12 : 6 }}
        columnStart={{ large: 1 }}
        className={styles.content}
      >
        {!basic && (
          <div className={styles.contentText}>
            <PageTitle pageTitle={title} pageTitleTag="h1" standfirst={standfirst} />
          </div>
        )}
        <PISearchBox {...searchBar} onValueChange={setSearchTerm} />
        {!basic && <PIRole headingText={subtext} buttons={buttonsRole} searchTerm={searchTerm} />}
      </GridItem>

      {!basic && (
        <GridItem
          span={{ large: 6 }}
          columnStart={{ large: 7 }}
          className={styles.heroWrapperImageContainer}
        >
          <Picture src={image} aspectRatioMain="three-to-one" />
        </GridItem>
      )}
    </Grid>
  )
}

///////// IMPLEMENTATION /////////

type Props = {
  title: string
  standfirst: string
  searchBar: { placeholderText: string; buttonText: string }
  basic?: boolean
  subtext?: string | ''
  buttonsRole?: Array<{ id: string; displayText: string; href: string }>
  image: string
}
